import { getCampaigns } from '../services';
export const fetchCampaigns = () => getCampaigns().then(response => formatResponse(response?.data));
const formatResponse = (response) => {
    return response?.data.map(campaign => ({
        label: campaign?.name,
        value: campaign?.id,
    }));
};
